<template>
    <v-container class="content-wrapper">
        <v-row
            v-if="featuredTestimonials && featuredTestimonials.length > 0"
            column
            justify-center
            align-center
            :class="{ 'featured-wrapper': true, featuredTestimonials: true }"
        >
            <v-col
                v-for="(card, i) in featuredTestimonials"
                :key="`profile${i}`"
                cols="6"
                xs="6"
                sm="6"
                md="4"
                lg="3"
                xl="3"
            >
                <CardSingleTestimonial :post="card" :img-crop="setCrop()" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import colorUtilities from '~/mixins/colorUtilities'
import postUtilities from '~/mixins/postUtilities'
import CardSingleTestimonial from '~/components/cards/CardSingleTestimonial.vue'
export default {
    name: 'FeaturedTestimonials',
    components: {
        CardSingleTestimonial
    },
    mixins: [colorUtilities, postUtilities],
    props: {},
    methods: {}
}
</script>
